import React, { useRef, useState, useEffect } from 'react';
import * as Yup from 'yup';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik, Form, Field, ErrorMessage } from 'formik';

import { APP_LABELS, FIELD_LENGTH } from '@config/app-config';
import Help from '@modules/shared/components/reusable-components/help';

import TextError from '@modules/shared/components/reusable-components/text-error';
import SuccessToaster from '@modules/shared/components/reusable-components/success-toaster';
import ErrorPopup from '@modules/employee-data-collection/components/upload-file/error-popup';
import PartialSaveWarningPopup from '@modules/shared/components/reusable-components/partial-save-popup';
import LastUpdateName from '@modules/annual-reports/components/anuual-reports-overview/last-update-name';

import {
  resetReduxState,
  postOvernightCampDataRevenue,
  getOvernightCampDataRevenueList
} from '@redux/overnight-camp-data-financials/action';
import { getCampReportsDashboardOverviewData } from '@redux/overnight-camp-data-overview/action';

import { AssociationAdminLoginDetailsSelector } from '@redux/login/selectors';
import { ApiParaSelector } from '@redux/overnight-camp-data-apiParameter/selectors';
import { YusaOvernightCampGetRevenueSelector } from '@redux/overnight-camp-data-financials/selectors';

import helpicon from '@static/images/caretdoubleright.svg';

const Revenue = props => {
  const formikref = useRef();
  const {
    status,
    setLoader,
    LoginUserData,
    getRevenueData,
    ApiParameterData,
    handleResetRedux,
    handlePostRevenueData,
    handleGetRevenueDetails,
    handleGetCampReportsDashboard
  } = props;

  const role = get(LoginUserData, 'user.role[0]');

  const [help, setHelp] = useState(false);
  const [instructions, setInstructions] = useState('');
  const [errorPopup, setErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successPopup, setSuccessPopup] = useState(false);

  const [resStatus, setResStatus] = useState();

  const initialValues = {
    totalOperatingRevenue: '',
    totalNonOperatingRevenue: '',
    grandTotalRevenue: '',

    feesSpecializedCamps: '',
    activityTransportationInsuranceFees: '',
    campStoreRevenue: '',
    contributionsScholarshipsCamperships: '',
    annualCharitableSupport: '',
    capitalContributions: '',
    endowmentContributions: '',
    anyOtherRevenueNotMentionedAbove: '',
    anyOtherRevenueNotMentionedAboveAmount: '',
    total: ''
  };

  const editValues = {
    totalOperatingRevenue: getRevenueData?.data?.TotalOperatingRevenue,
    totalNonOperatingRevenue: getRevenueData?.data?.TotalNonOperatingRevenue,
    grandTotalRevenue: getRevenueData?.data?.grandTotalRevenue ?? '',
    feesSpecializedCamps: getRevenueData?.data?.PeopleWithDiverseAbilitiesFees,
    activityTransportationInsuranceFees:
      getRevenueData?.data?.ActivityTransportationInsuranceFee,
    campStoreRevenue: getRevenueData?.data?.CampStoreRevenue,
    contributionsScholarshipsCamperships:
      getRevenueData?.data?.ContributionsScholarshipsCamperships,
    annualCharitableSupport: getRevenueData?.data?.AnnualCharitableSupport,
    capitalContributions: getRevenueData?.data?.CapitalContributions,
    endowmentContributions: getRevenueData?.data?.EndowmentContributions,
    anyOtherRevenueNotMentionedAbove:
      getRevenueData?.data?.AnyOtherRevenueNotMentionedAbove,
    anyOtherRevenueNotMentionedAboveAmount:
      getRevenueData?.data?.AnyOtherRevenueNotMentionedAboveAmount,
    total: getRevenueData?.data?.total ?? ''
  };

  const validationSchema = Yup.object({
    totalOperatingRevenue: Yup.string().nullable(),
    totalNonOperatingRevenue: Yup.string().nullable(),
    grandTotalRevenue: Yup.string().nullable(),

    feesSpecializedCamps: Yup.string().nullable(),
    activityTransportationInsuranceFees: Yup.string().nullable(),
    campStoreRevenue: Yup.string().nullable(),
    contributionsScholarshipsCamperships: Yup.string().nullable(),
    annualCharitableSupport: Yup.string().nullable(),
    capitalContributions: Yup.string().nullable(),
    endowmentContributions: Yup.string().nullable(),
    anyOtherRevenueNotMentionedAbove: Yup.string().nullable(),
    anyOtherRevenueNotMentionedAboveAmount: Yup.string().nullable(),
    total: Yup.string().nullable()
  });
  const handelGetCall = success => {
    setLoader(true);
    handleGetRevenueDetails(
      ApiParameterData?.branchNumber,
      ApiParameterData?.reportBatchId,
      ApiParameterData?.year
    )
      .then(res => {
        if (res && res.status && String(res.status).startsWith('2')) {
          setLoader(false);
          if (success) {
            setSuccessPopup(true);
          }
        } else {
          setLoader(false);
          setErrorMessage(APP_LABELS.COMMON_ERROR_MESSAGE);
          setErrorPopup(true);
        }
      })
      .catch(error => {
        setLoader(false);
        setErrorMessage(APP_LABELS.COMMON_ERROR_MESSAGE);
        setErrorPopup(true);
      });
  };
  useEffect(() => {
    handelGetCall();
    setInstructions(
      JSON.parse(sessionStorage.getItem('allinstructions'))['revenue']
        ?.Instruction
    );
    return () => {
      handleResetRedux('YusaOvernightCampRevenueList');
    };
  }, []);

  const handleShowHelp = () => {
    setHelp(true);
  };

  const hideShowHelp = () => {
    setHelp(false);
  };

  const getClassNames = (errorsValue, touchedValue, checkboxValue) => {
    let className = 'ymca-field';

    if (errorsValue && touchedValue) {
      className = 'ymca-field invalid';
    } else if (checkboxValue) {
      className = 'ymca-field ymca-fieldDisabled';
    }
    return className;
  };

  const handleChange = (e, setFieldValue, name) => {
    const result = e.target.value.replace(/\D+/g, '');
    setFieldValue(name, result);
  };

  const calculateTotal = (
    number1 = 0,
    number2 = 0,
    number3 = 0,
    number4 = 0,
    number5 = 0,
    number6 = 0,
    number7 = 0,
    number8 = 0
  ) =>
    Number(number1) +
    Number(number2) +
    Number(number3) +
    Number(number4) +
    Number(number5) +
    Number(number6) +
    Number(number7) +
    Number(number8);

  const convertedValue = value => (value === 0 || value ? Number(value) : null);

  const onSubmit = values => {
    setLoader(true);

    const payloadBody = {
      data: {
        CampRevenueId:
          getRevenueData?.data?.CampRevenueId === undefined
            ? 0
            : getRevenueData.data.CampRevenueId,

        Year: ApiParameterData?.year,
        BranchNumber: ApiParameterData?.branchNumber,
        ReportBatchId: ApiParameterData?.reportBatchId,

        TotalOperatingRevenue: convertedValue(values?.totalOperatingRevenue),
        TotalNonOperatingRevenue: convertedValue(
          values?.totalNonOperatingRevenue
        ),
        PeopleWithDiverseAbilitiesFees: convertedValue(
          values?.feesSpecializedCamps
        ),
        ActivityTransportationInsuranceFee: convertedValue(
          values?.activityTransportationInsuranceFees
        ),
        CampStoreRevenue: convertedValue(values?.campStoreRevenue),
        ContributionsScholarshipsCamperships: convertedValue(
          values?.contributionsScholarshipsCamperships
        ),
        AnnualCharitableSupport: convertedValue(
          values?.annualCharitableSupport
        ),
        CapitalContributions: convertedValue(values?.capitalContributions),
        EndowmentContributions: convertedValue(values?.endowmentContributions),
        AnyOtherRevenueNotMentionedAbove: convertedValue(
          values?.anyOtherRevenueNotMentionedAbove
        ),
        AnyOtherRevenueNotMentionedAboveReason:
          values?.anyOtherRevenueNotMentionedAboveAmount ?? '',
        Total: calculateTotal(
          values.feesSpecializedCamps,
          values.activityTransportationInsuranceFees,
          values.campStoreRevenue,
          values.contributionsScholarshipsCamperships,
          values.annualCharitableSupport,
          values.capitalContributions,
          values.endowmentContributions,
          values.anyOtherRevenueNotMentionedAbove
        ),

        RecordStatus: getRevenueData?.data?.RecordStatus || '',
        CreatedByPersonId: LoginUserData?.user?.personBranchId,
        UpdatedByPersonId: LoginUserData?.user?.personBranchId
      },
      isSuccess: getRevenueData?.isSuccess || false
    };

    setSuccessPopup(false);

    handlePostRevenueData(payloadBody).then(res => {
      if (res && res.status === 201 && res.data.isSuccess) {
        setResStatus(res.data?.recordStatus);
        handelGetCall(true);
        handleGetCampReportsDashboard(
          ApiParameterData?.branchNumber,
          ApiParameterData?.year
        );
      } else if (res.statusCode === 409) {
        setLoader(false);
        setErrorMessage(res.errorMessage);
        setErrorPopup(true);
      } else {
        setLoader(false);
        setErrorPopup(true);
      }
    });
  };

  return (
    <>
      <button
        type="button"
        className="ymca-help-link text-decoration-none ymca-up-data-help-link annual-report-help"
        onClick={handleShowHelp}
      >
        <span>HELP</span>
        <img src={helpicon} className="img-fluid" alt="caret-icon" />
      </button>

      <div className="ymca-program mb-2">
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-2 pb-3">
          <div className="ymca-instructionBoxes">
            <h4 className="ymca-instructHeadline">{APP_LABELS.INSTRUCTIONS}</h4>
            <p className="ymca-instructTitle">
              <div
                dangerouslySetInnerHTML={{
                  __html: instructions
                }}
              />
            </p>
          </div>
        </div>

        {getRevenueData?.data?.RecordStatus === 'Partial' && (
          <PartialSaveWarningPopup />
        )}

        <Formik
          innerRef={formikref}
          initialValues={editValues || initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          enableReinitialize
        >
          {({ values, setFieldValue, errors, touched, dirty }) => {
            sessionStorage.setItem('dirty', dirty);
            return (
              <Form autoComplete="off">
                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                  <div className="ymca-selectWrap">
                    <div className="ymca-programActivities txt-mandatory">
                      What was your Overnight Summer Camp's total operating
                      revenue for the summer?
                    </div>
                  </div>
                </div>
                <div className="ymca-tableResponsive">
                  <table className="table ymca-table table-striped ymca-autoLength">
                    <thead>
                      <tr className="ymca-cuttingData">
                        <th>&nbsp;</th>
                        <th>$</th>
                        <th className="ymca-defaultSpace">&nbsp;</th>
                        <th className="ymca-defaultSpace">&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody className="ymca-cuttingBody ymca-lengths">
                      <tr>
                        <td>
                          <div className="txt-mandatory">
                            Total Operating Revenue
                          </div>
                          <div className="ymca-lighter-gray-text">
                            Do not include Non-Operating Revenue such as
                            contributions for capital improvement or endowment.
                            Please do include Camp Store Revenue, Scholarships
                            and Annual Charitable Support. Do not include
                            revenue from other programs or services offered such
                            as Day Camp, Retreats, Conferences, etc.
                          </div>
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="totalOperatingRevenue"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.totalOperatingRevenue,
                              touched.totalOperatingRevenue
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'totalOperatingRevenue'
                              )
                            }
                            value={values.totalOperatingRevenue}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="totalOperatingRevenue"
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td>
                          <div className="txt-mandatory">
                            Total Non-Operating Revenue
                          </div>
                          <div className="ymca-lighter-gray-text">
                            Include any revenue not accounted for in operating
                            revenue such as capital or endowment contributions.
                          </div>
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="totalNonOperatingRevenue"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.totalNonOperatingRevenue,
                              touched.totalNonOperatingRevenue
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'totalNonOperatingRevenue'
                              )
                            }
                            value={values.totalNonOperatingRevenue}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="totalNonOperatingRevenue"
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="">Grand Total Revenue</td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="grandTotalRevenue"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className="ymca-field ymca-fieldDisabled"
                            value={calculateTotal(
                              values.totalOperatingRevenue,
                              values.totalNonOperatingRevenue
                            )}
                            disabled
                          />
                          <ErrorMessage
                            component={TextError}
                            name="grandTotalRevenue"
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                  <div className="ymca-selectWrap">
                    <div className="ymca-programActivities txt-mandatory">
                      Please provide the following detail on your Overnight
                      Camp's Revenue from last year. Do not include those from
                      other programs or services offered such as Day Camp,
                      Retreats, Conferences, etc. If none, enter '0'.
                      {/* The total
                      reported here should match the total revenue reported in
                      the previous question. */}
                    </div>
                  </div>
                </div>

                <div className="ymca-tableResponsive">
                  <table className="table ymca-table table-striped ymca-autoLength">
                    <thead>
                      <tr className="ymca-cuttingData">
                        <th>&nbsp;</th>
                        <th>$</th>
                        <th className="ymca-defaultSpace">&nbsp;</th>
                        <th className="ymca-defaultSpace">&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody className="ymca-cuttingBody ymca-lengths">
                      <tr>
                        <td className="txt-mandatory">
                          Fees from specialized Camps for people with diverse
                          abilities fees (if not represented above)
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="feesSpecializedCamps"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.feesSpecializedCamps,
                              touched.feesSpecializedCamps
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'feesSpecializedCamps'
                              )
                            }
                            value={values.feesSpecializedCamps}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="feesSpecializedCamps"
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">
                          Activity/Transportation/Insurance fees
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="activityTransportationInsuranceFees"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.activityTransportationInsuranceFees,
                              touched.activityTransportationInsuranceFees
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'activityTransportationInsuranceFees'
                              )
                            }
                            value={values.activityTransportationInsuranceFees}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="activityTransportationInsuranceFees"
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="txt-mandatory">Camp Store Revenue</td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="campStoreRevenue"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.campStoreRevenue,
                              touched.campStoreRevenue
                            )}
                            onChange={e =>
                              handleChange(e, setFieldValue, 'campStoreRevenue')
                            }
                            value={values.campStoreRevenue}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="campStoreRevenue"
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td>
                          <div className="txt-mandatory">
                            Contributions for Scholarships/Camperships
                          </div>
                          <div className="ymca-lighter-gray-text">
                            Exclude capital or endowment contributions,
                            endowment transfers for operations, and govemment
                            contracts.
                          </div>
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="contributionsScholarshipsCamperships"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.contributionsScholarshipsCamperships,
                              touched.contributionsScholarshipsCamperships
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'contributionsScholarshipsCamperships'
                              )
                            }
                            value={values.contributionsScholarshipsCamperships}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="contributionsScholarshipsCamperships"
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td>
                          <div className="txt-mandatory">
                            Annual Charitable Support
                          </div>
                          <div className="ymca-lighter-gray-text">
                            Include all general contributions, annual campaign
                            contributions, special events (net), international,
                            federated campaigns, corporate/ foundation grants
                            and government grants. Exclude contributions for
                            scholarships/camperships listed above. Exclude
                            capital or endowment contributions, endowment
                            transfers for operations, and government contracts.
                          </div>
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="annualCharitableSupport"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.annualCharitableSupport,
                              touched.annualCharitableSupport
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'annualCharitableSupport'
                              )
                            }
                            value={values.annualCharitableSupport}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="annualCharitableSupport"
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td>
                          <div className="txt-mandatory">
                            Capital Contributions
                          </div>
                          <div className="ymca-lighter-gray-text">
                            Contributions toward capital expenses made during
                            fiscal year. Gifts actually received not pledges for
                            future payment.
                          </div>
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="capitalContributions"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.capitalContributions,
                              touched.capitalContributions
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'capitalContributions'
                              )
                            }
                            value={values.capitalContributions}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="capitalContributions"
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td>
                          <div className="txt-mandatory">
                            Endowment Contributions
                          </div>
                          <div className="ymca-lighter-gray-text">
                            Contributions toward endowments made during the most
                            recent fiscal year.
                          </div>
                        </td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="endowmentContributions"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.endowmentContributions,
                              touched.endowmentContributions
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'endowmentContributions'
                              )
                            }
                            value={values.endowmentContributions}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="endowmentContributions"
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="d-flex align-items-center">
                          <div className="txt-mandatory">
                            Any other revenue not mentioned above. Please
                            specify
                          </div>
                          <td className="ymca-fieldLine">
                            <Field
                              name="anyOtherRevenueNotMentionedAboveAmount"
                              type="text"
                              maxLength="100"
                              className={`ms-3 ${getClassNames(
                                errors.anyOtherRevenueNotMentionedAboveAmount,
                                touched.anyOtherRevenueNotMentionedAboveAmount
                              )}`}
                              onChange={e =>
                                setFieldValue(
                                  'anyOtherRevenueNotMentionedAboveAmount',
                                  e.target.value
                                )
                              }
                              value={
                                values.anyOtherRevenueNotMentionedAboveAmount
                              }
                            />
                            <ErrorMessage
                              component={TextError}
                              name="anyOtherRevenueNotMentionedAboveAmount"
                            />
                          </td>
                        </td>

                        <td className="ymca-fieldLine">
                          <Field
                            name="anyOtherRevenueNotMentionedAbove"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className={getClassNames(
                              errors.anyOtherRevenueNotMentionedAbove,
                              touched.anyOtherRevenueNotMentionedAbove
                            )}
                            onChange={e =>
                              handleChange(
                                e,
                                setFieldValue,
                                'anyOtherRevenueNotMentionedAbove'
                              )
                            }
                            value={values.anyOtherRevenueNotMentionedAbove}
                          />
                          <ErrorMessage
                            component={TextError}
                            name="anyOtherRevenueNotMentionedAbove"
                          />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>

                      <tr>
                        <td className="">Total</td>
                        <td className="ymca-fieldLine">
                          <Field
                            name="total"
                            type="text"
                            maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            className="ymca-field ymca-fieldDisabled"
                            value={calculateTotal(
                              values.feesSpecializedCamps,
                              values.activityTransportationInsuranceFees,
                              values.campStoreRevenue,
                              values.contributionsScholarshipsCamperships,
                              values.annualCharitableSupport,
                              values.capitalContributions,
                              values.endowmentContributions,
                              values.anyOtherRevenueNotMentionedAbove
                            )}
                            disabled
                          />
                          <ErrorMessage component={TextError} name="total" />
                        </td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                        <td className="ymca-defaultSpace">&nbsp;</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="ymca-submitHighlighter">
                  <LastUpdateName
                    Username={getRevenueData?.data?.UpdatedByName}
                    Time={getRevenueData?.data?.UpdatedDateTime}
                  />
                </div>
                {role !== APP_LABELS.YUSA_DATA_VIEWER && (
                  <button
                    type="submit"
                    className="btn ymca-savingBTN ymca-btnRightUntitled float-end mt-5"
                    disabled={
                      status?.toUpperCase() === APP_LABELS.STATUS_SUBMITTED
                    }
                  >
                    Save
                  </button>
                )}
              </Form>
            );
          }}
        </Formik>
      </div>
      {successPopup && <SuccessToaster Status={resStatus} />}

      <ErrorPopup
        handleCloseErrorPopup={() => {
          setErrorPopup(false);
        }}
        errorMessage={errorMessage}
        showErrorPopup={errorPopup}
      />
      {help && <Help hidePopup={hideShowHelp} keyValue="revenue" />}
    </>
  );
};

Revenue.propTypes = {
  setLoader: PropTypes.func.isRequired,
  handleResetRedux: PropTypes.func.isRequired,
  handlePostRevenueData: PropTypes.func.isRequired,
  handleGetRevenueDetails: PropTypes.func.isRequired,
  handleGetCampReportsDashboard: PropTypes.func.isRequired,

  status: PropTypes.objectOf(PropTypes.any).isRequired,
  LoginUserData: PropTypes.objectOf(PropTypes.any).isRequired,
  getRevenueData: PropTypes.objectOf(PropTypes.any).isRequired,
  ApiParameterData: PropTypes.objectOf(PropTypes.any).isRequired
};

const mapDispatchToProps = {
  handleResetRedux: resetReduxState,
  handlePostRevenueData: postOvernightCampDataRevenue,
  handleGetRevenueDetails: getOvernightCampDataRevenueList,
  handleGetCampReportsDashboard: getCampReportsDashboardOverviewData
};

const mapStateToProps = state => ({
  ApiParameterData: ApiParaSelector(state),
  LoginUserData: AssociationAdminLoginDetailsSelector(state),
  getRevenueData: YusaOvernightCampGetRevenueSelector(state)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(Revenue));
